export enum RoutePath {
    admin= "/",
    dashboard = "/dashboard",
    campaign= "/campaign",
    newCampaign= "/campaign/new_campaign",
    campaignStatistic= "/campaign/campaign_statistic",
    patients= "/patients",
    newGroup= "/patients/new_group",
    communications= "/communications",
    engagementAnalytics= "/engagement_analytics",
    costAnalytics= "/cost_analytics",
    loginFailed= "/loginFailed",
    updatePatientInfo = "/updateInfo",
    conversations = "/conversations",
    surveys = "/surveys",
    surveysTemplate = "/surveys/template",
    surveysBuilder = "/surveys/builder",
}
